import { useNavigate, useSearchParams } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";

const ManageVehicleDetail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "Car";

  // Dynamic data for each type
  const vehicleData: Record<string, any> = {
    Car: {
      name: "Mercedes-Benz C-Class",
      price: "$42,900",
      category: "Car",
      subCategory: "Sedan",
      location: "San Francisco, CA 94105",
      vehicleNumber: "D9_647949",
      availability: "Immediately",
      condition: "New",
      shortDesc: "The AMG E53 Cabriolet is the embodiment of Italian engineering and design excellence. This high-performance is powered by a 3.9-liter twin-turbocharged V8 engine, producing a breathtaking 661 horsepower and 760 Nm of torque.",
      fullDesc: "The Mercedes-Benz C-Class Cabriolet represents the pinnacle of German engineering and design sophistication. This stunning convertible is equipped with a robust 3.9-liter twin-turbo V8 engine, delivering an exhilarating 661 horsepower and an impressive 760 Nm of torque. With its sleek lines and luxurious interior, this car not only offers high performance but also a refined driving experience that turns every journey into a memorable adventure. The Mercedes-Benz C-Class Cabriolet represents the pinnacle of German engineering and design sophistication. This stunning convertible is equipped with a robust 3.9-liter twin-turbo V8 engine, delivering an exhilarating 661 horsepower and an impressive 760 Nm of torque. With its sleek lines and luxurious interior, this car not only offers high performance but also a refined driving experience that turns every journey into a memorable adventure.",
      createdDate: "01-Sept-2025",
    },
    Bike: {
      name: "Ducati Streetfighter ",
      price: "$15,$42,900",
      category: "Bike",
      subCategory: "Sports",
      location: "San Francisco, CA 94105",
      vehicleNumber: "D9_647949",
      availability: "Immediately",
      condition: "Used",
      shortDesc: "The AMG E53 Cabriolet is the embodiment of Italian engineering and design excellence. This high-performance is powered by a 3.9-liter twin-turbocharged V8 engine, producing a breathtaking 661 horsepower and 760 Nm of torque.",
      fullDesc: "The Ducati Streetfighter is a bold and aggressive motorcycle that embodies the spirit of naked bike performance. With its powerful 1,103cc V4 engine, it produces a thrilling 208 horsepower, ensuring an exhilarating ride on both city streets and winding roads. The bike features a lightweight trellis frame that enhances agility and handling, making it perfect for those who crave speed and precision. Its striking design, characterized by sharp lines and a minimalist aesthetic, turns heads wherever it goes. The advanced electronics package includes multiple riding modes, traction control, and cornering ABS, providing riders with confidence and control in any condition. Whether you're commuting or tearing up the track, the Ducati Streetfighter delivers an unmatched experience that combines raw power with cutting-edge technology.",
      createdDate: "02-Sept-2025",
    },
    Bicycle: {
      name: "Riese & Müller Nevo4 GT Automatic",
      price: "$3,200",
      category: "Bicycle",
      subCategory: "E-Bike",
      location: "San Francisco, CA 94105",
      vehicleNumber: "D9_647949",
      availability: "Immediately",
      condition: "New",
      shortDesc: "Introducing the Apex Cruiser, the ultimate electric bike that will revolutionize your cycling adventures! Equipped with a robust 750W motor",
      fullDesc: "Introducing the Apex Cruiser, the ultimate electric bike that will revolutionize your cycling adventures! Equipped with a robust 750W motor, this bike allows you to effortlessly zoom through city streets at an exhilarating speed of up to 28 mph. Its lightweight carbon frame and sleek aerodynamic design not only enhance your speed but also improve your maneuverability on various terrains. Experience the joy of long rides in unparalleled comfort with its plush saddle and ergonomic grips, meticulously crafted for those who have a passion for exploration. Safety and convenience are at the forefront of the Apex Cruiser, featuring integrated LED lights that ensure visibility during nighttime rides and a state-of-the-art smart display that tracks all your performance metrics. The Apex Cruiser is more than just a bike; it’s your gateway to thrilling adventures and unforgettable experiences on two wheels!",
      createdDate: "03-Sept-2025",
    },
    Caravan: {
      name: "Carado T 334 / T65",
      price: "$42,900",
      category: "Caravan",
      subCategory: "Travel",
      location: "San Francisco, CA 94105",
      vehicleNumber: "D9_647949",
      availability: "Immediately",
      condition: "Used",
      shortDesc: "The AMG E53 Cabriolet is the embodiment of Italian engineering and design excellence. This high-performance is powered by a 3.9-liter twin-turbocharged V8 engine, producing a breathtaking 661 horsepower and 760 Nm of torque.",
      fullDesc: "The Mercedes-Benz C-Class Cabriolet represents the pinnacle of German engineering and design sophistication. This stunning convertible is equipped with a robust 3.9-liter twin-turbo V8 engine, delivering an exhilarating 661 horsepower and an impressive 760 Nm of torque. With its sleek lines and luxurious interior, this car not only offers high performance but also a refined driving experience that turns every journey into a memorable adventure. The Mercedes-Benz C-Class Cabriolet represents the pinnacle of German engineering and design sophistication. This stunning convertible is equipped with a robust 3.9-liter twin-turbo V8 engine, delivering an exhilarating 661 horsepower and an impressive 760 Nm of torque. With its sleek lines and luxurious interior, this car not only offers high performance but also a refined driving experience that turns every journey into a memorable adventure.",
      createdDate: "05-Sept-2025",
    },
    Trucks: {
      name: "Tata Truck H410",
      price: "$42,900",
      category: "Truck",
      subCategory: "Heavy Duty",
      location: "San Francisco, CA 94105",
      vehicleNumber: "D9_647949",
      availability: "Immediately",
      condition: "Used",
      shortDesc: "The AMG E53 Cabriolet is the embodiment of Italian engineering and design excellence. This high-performance is powered by a 3.9-liter twin-turbocharged V8 engine, producing a breathtaking 661 horsepower and 760 Nm of torque.",
      fullDesc: "The Mercedes-Benz C-Class Cabriolet represents the pinnacle of German engineering and design sophistication. This stunning convertible is equipped with a robust 3.9-liter twin-turbo V8 engine, delivering an exhilarating 661 horsepower and an impressive 760 Nm of torque. With its sleek lines and luxurious interior, this car not only offers high performance but also a refined driving experience that turns every journey into a memorable adventure. The Mercedes-Benz C-Class Cabriolet represents the pinnacle of German engineering and design sophistication. This stunning convertible is equipped with a robust 3.9-liter twin-turbo V8 engine, delivering an exhilarating 661 horsepower and an impressive 760 Nm of torque. With its sleek lines and luxurious interior, this car not only offers high performance but also a refined driving experience that turns every journey into a memorable adventure.",
      createdDate: "05-Sept-2025",
    },
    "Heavy Equipment": {
      name: "Caterpillar Excavator 320",
      price: "$42,900",
      category: "Heavy Equipment",
      subCategory: "Construction",
      location: "San Francisco, CA 94105",
      vehicleNumber: "D9_647949",
      availability: "Immediately",
      condition: "New",
      shortDesc: "The AMG E53 Cabriolet is the embodiment of Italian engineering and design excellence. This high-performance is powered by a 3.9-liter twin-turbocharged V8 engine, producing a breathtaking 661 horsepower and 760 Nm of torque.",
      fullDesc: "The Caterpillar Excavator 320 is a robust and versatile machine designed for heavy-duty construction tasks. Equipped with a powerful engine, it delivers exceptional performance, making it ideal for digging, lifting, and moving materials on any job site. The 320 features a durable undercarriage and a spacious cab, providing operators with comfort and visibility while working long hours. Its advanced hydraulic system ensures precise control and efficiency, allowing for smooth operation in various terrains. With a range of attachments available, the Caterpillar Excavator 320 can adapt to different tasks, from trenching to demolition. This excavator is built to withstand the rigors of tough environments, making it a reliable choice for contractors looking to maximize productivity.",
      createdDate: "06-Sept-2025",
    },
  };

  const vehicle = vehicleData[type];

  const sparePartInfo = [
    { label: "Ad Title", value: vehicle.name },
    {
      label: "Price",
      value: (
        <>
          <strong className="c_primary">{vehicle.price}</strong> (Fixed)
        </>
      ),
    },
    { label: "Sub Category", value: vehicle.subCategory },
    { label: "Location", value: vehicle.location },
    { label: "Vehicle Number", value: vehicle.vehicleNumber },
    { label: "Availability", value: vehicle.availability },
    { label: "Small Description", value: vehicle.shortDesc },
    { label: "Full Description", value: vehicle.fullDesc },
    {
      label: "Featured Vehicle",
      value: <SwitchToggle defaultChecked />,
    },
    {
      label: "Leasing Black Week Deal",
      value: <SwitchToggle defaultChecked />,
    },
    { label: "Created Date", value: vehicle.createdDate },
  ];

  const dealerInfo = [
    {
      label: "Dealer Name",
      value: (
        <strong
          className="anchor_link"
          onClick={() => navigate("/manage-dealers/detail")}
        >
          John Motors
        </strong>
      ),
    },
    { label: "Phone Number", value: "9876543210" },
    { label: "Email", value: "johnmotors@gmail.com" },
  ];

  const images = [
    "/static/images/placeholder.png",
    "/static/images/placeholder.png",
    "/static/images/placeholder.png",
  ];

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>{type} Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-vehicles")}>Listed Vehicles</button>{" "}
          – {type} Detail
        </p>
      </div>

      {/* ================= Card 1: Listed Vehicles Info ================= */}
      <div className="cards view_page">
        <div className="table_header mb_20">
          <h2 className="flex">Listed Information <span className="status_btn c_dark_primary">{type}</span></h2>
          <div className="btn_flex">
            <span className="status_btn dark c_success">Active</span>
            <span className="status_btn c_dark_info">{vehicle.condition}</span>
          </div>
        </div>

        <div className="gap_p">
          {/* Images */}
          <div className="w_100">
            <h6>Listed Vehicles Images</h6>
            <div className="gap_p">
              {images.map((img, index) => (
                <div className="w_25" key={index}>
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img src={img} className="view_img" alt="" />
                    </figure>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="w_100">
            <h6>YouTube video</h6>
            <p><a className="click_action" href="https://www.youtube.com/watch?v=zyx" target="_blank" rel="noreferrer">https://www.youtube.com/watch?v=zyx</a></p>
          </div>

          {/* Listed Vehicles Details */}
          {sparePartInfo.map((item, index) => (
            <div
              className={item.label.includes("Description") ? "w_100" : "w_33"}
              key={index}
            >
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Technical Data</h2>
        </div>
        <div className="gap_p">
          {[
            { label: "Brand", value: "Mercedes-Benz" },
            { label: "Model", value: "C-Class" },
            { label: "First Registration", value: "March 2022" },
            { label: "Year of Construction", value: "2022" },
            { label: "Number of Beds", value: "4" },
            { label: "Length", value: "4500 mm" },
            { label: "Width", value: "1800 mm" },
            { label: "Height", value: "1600 mm" },
            { label: "Maximum Weight Allowed", value: "2000 kg" },
            { label: "Axles", value: "2" },
            { label: "Fuel Type", value: "Petrol" },
            { label: "Engine Power", value: "200 HP" },
            { label: "Transmission", value: "Automatic" },
            { label: "Drive Type", value: "AWD" },
            { label: "Emission Class", value: "Euro 6" },
            { label: "Environmental Badge", value: "Green Badge" },
            { label: "Mileage", value: "12000 km" },
            { label: "Vehicle Type", value: "SUV" },
            { label: "Number of Owners", value: "1" },
            { label: "Damaged Car", value: "No" },
            { label: "HU Valid Until", value: "August 2025" },
            { label: "GCC" },
            { label: "Miles", value: "1000" },
            { label: "Manufacture Color", value: "Silver Metallic" },
          ].map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Vehicle Color</h2>
        </div>
        <div className="gap_p">
          {[
            { label: "Interior color", value: "Black" },
            { label: "Exterior color", value: "Silver Metallic" },
          ].map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Features</h2>
        </div>
        <div className="gap_p gap_sm">
          {[
            { label: "Anti-lock braking system (ABS)" },
            { label: "Electronic Stability Program (ESP)" },
            { label: "Cruise Control", value: "Standard, Adaptive, Intelligent" },
            { label: "Stationary air conditioning" },
            { label: "Auxiliary heater" },
            { label: "Heated seats" },
            { label: "Self-steering systems" },
            { label: "Acoustic parking aid - In front" },
            { label: "Acoustic parking aid - Rear" },
            { label: "Visual parking aid - Camera" },
            { label: "Visual parking aid - 360° camera" },
            { label: "Central seating group" },
            { label: "Round seating area" },
            { label: "Side seating group" },
            { label: "Fixed bed" },
            { label: "Bunk bed" },
            { label: "WC" },
            { label: "Separate shower" },
            { label: "Central locking" },
            { label: "Power steering" },
            { label: "TV" },
            { label: "Navigation system" },
            { label: "Rear garage" },
            { label: "Awning" },
            { label: "Solar system" },
          ].map((item, index) => (
            <div className="w_33 flex_items" key={index}>
              <span className="c_primary">✔</span>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Dealer Information</h2>
        </div>
        <div className="gap_p">
          {dealerInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ManageVehicleDetail;
